import { get } from "lodash"
import { createQueryStringSelector } from "selectors/queryString"

export const getAccountsDetails = state => get(state, "global.data.accounts.data")
export const getName = state => get(state, "user.name")
export const getIsSuperuser = state => get(state, "user.isSuperuser")
export const getPartnersDetails = state => get(state, "global.data.partners.data")

export const getRedirectUrl = createQueryStringSelector("redirect")
